const state = [];

const mutations = {
    createProcess(state, id) {
        let item = {id: id, message: null, status: null};
        state.forEach((entry, i) => {
            if (entry.id === item.id) {
                state.splice(i, 1);
            }
        });
        state.push(item);
    },
    destroyProcess(state, id) {
        state.forEach((entry, i) => {
            if (entry.id === id) {
                state.splice(i, 1);
            }
        });
    },
    setProcessSuccess(state, id) {
        state.forEach(entry => {
            if (entry.id === id) {
                entry.message = null;
                entry.status = true;
            }
        });
    },
    setProcessFailed(state, params) {
        state.forEach(entry => {
            if (entry.id === params.id) {
                entry.status = false;
                entry.message = params.message;
                entry.code = params.code;
            }
        });
    }
};

const getters = {
    getProcessError: (state, getters) => (id) => {
        let message = null;
        state.forEach(entry => {
            if (entry.id === id)
                message = entry.message;
        });
        return message;
    },
    getProcessStatus: (state, getters) => (id) => {
        let status = null;
        state.forEach(entry => {
            if (entry.id === id) {
                status = entry.status;
            }
        });
        return status;
    },
    getProcessCode: (state, getters) => (id) => {
        let code = -1;
        state.forEach(entry => {
            if (entry.id === id) {
                code = entry.code;
            }
        });
        return code;
    }
};

const actions = {
    createProcess({commit}, id) {
        commit('createProcess', id);
    },
    destroyProcess({commit}, id) {
        commit('destroyProcess', id);
    },
    setProcessSuccess({commit}, id) {
        commit('setSuccess', id);
    },
    setProcessFailed({commit}, params) {
        commit('setFailed', params);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/process.js